import { JSX } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import ContactsForm from "@/components/contacts/ContactsForm.tsx";
import ContactsInformation from "@/components/contacts/ContactsInformation.tsx";

const ContactsPage = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("contacts.contacts")}</title>
      </Helmet>
      <div className={"bg-surface-bright space-y-10 rounded-7.5 px-5 py-10 max-lg:space-y-6 max-lg:px-4 max-lg:py-6"}>
        <h1 className={"text-4xl font-semibold max-lg:text-3xl/10"}>{t("contacts.contacts")}</h1>
        <div className={"flex justify-between gap-6 max-lg:flex-col"}>
          <ContactsInformation />
          <ContactsForm />
        </div>
      </div>
    </>
  );
};

export default ContactsPage;
